// extracted by mini-css-extract-plugin
module.exports = {"jobList":"JobList_jobList__2THIt","jobTable":"JobList_jobTable__2UwwU"};